(() => {
  'use strict';

  const VERSION = 'header-phone-locations-v3';
  const HEADER_SECTION_SELECTOR = '.section-header';
  const HEADER_SELECTOR = '.header';
  const CONTACT_SELECTOR = '[data-cap-header-contact]';

  const clean = (value) => String(value == null ? '' : value).replace(/\s+/g, ' ').trim();

  function shopRoot() {
    const root = clean(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : `${root}/`;
  }

  function isStoreHome() {
    const rootPath = new URL(shopRoot(), window.location.origin).pathname.replace(/\/+$/, '') || '/';
    const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
    return currentPath === rootPath;
  }

  function enhanceHomeLinks(section) {
    section.querySelectorAll('a[id^="HeaderMenu-"], a[id^="HeaderDrawer-"]').forEach((link) => {
      const span = link.querySelector('span');
      const label = span || link;
      const labelText = clean(label.textContent).toLowerCase();
      const fullText = clean(link.textContent).toLowerCase();
      if (labelText !== 'main website' && fullText !== 'main website') return;

      label.textContent = 'Home';
      link.href = shopRoot();
      link.classList.add('cap-header-home-link');
      link.dataset.capHeaderHome = 'true';

      if (isStoreHome()) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function disableHeaderSearch(section) {
    section.querySelectorAll('.header__search').forEach((search) => {
      search.dataset.capHeaderSearchHidden = 'true';
      search.setAttribute('aria-hidden', 'true');
    });
  }

  function buildContact() {
    const contact = document.createElement('div');
    contact.className = 'cap-header-contact';
    contact.dataset.capHeaderContact = VERSION;
    contact.setAttribute('aria-label', 'Call or text and yard locations');
    contact.innerHTML = `
      <div class="cap-header-mobile-summary" aria-label="Call or text and two locations">
        <span class="cap-header-mobile-summary__label">Call or Text</span>
        <a class="cap-header-mobile-summary__phone" href="tel:+19727527947" aria-label="Call (972) 752-7947">(972) 752-7947</a>
        <span class="cap-header-mobile-summary__locations">2 Locations</span>
      </div>
      <a class="cap-header-phone" href="tel:+19727527947" aria-label="Call (972) 752-7947">
        <span class="cap-header-phone__label">Call or Text</span>
        <strong class="cap-header-phone__number">(972) 752-7947</strong>
      </a>
      <div class="cap-header-locations" aria-label="Two locations">
        <span class="cap-header-locations__label">2 Locations</span>
        <div class="cap-header-locations__desktop-addresses" aria-label="Location addresses">
          <div class="cap-header-location-address cap-header-location-address--fort-worth">
            <strong>Fort Worth</strong>
            <address>3300 Van Horn Avenue<br>Fort Worth, Texas 76111</address>
          </div>
          <div class="cap-header-location-address cap-header-location-address--mesquite">
            <strong>Mesquite</strong>
            <address>124 Lakeside Road<br>Mesquite, Texas 75181</address>
          </div>
        </div>
        <div class="cap-header-locations__list">
          <details class="cap-header-location" data-cap-header-location>
            <summary class="cap-header-location__toggle">Fort Worth</summary>
            <div class="cap-header-location__panel">
              <strong>Fort Worth</strong>
              <address>3300 Van Horn Avenue<br>Fort Worth, TX 76111</address>
            </div>
          </details>
          <details class="cap-header-location" data-cap-header-location>
            <summary class="cap-header-location__toggle">Mesquite</summary>
            <div class="cap-header-location__panel">
              <strong>Mesquite</strong>
              <address>124 Lakeside Road<br>Mesquite, TX 75181</address>
            </div>
          </details>
        </div>
      </div>
    `;

    const locations = Array.from(contact.querySelectorAll('[data-cap-header-location]'));
    locations.forEach((location) => {
      location.addEventListener('toggle', () => {
        if (!location.open) return;
        locations.forEach((other) => {
          if (other !== location) other.removeAttribute('open');
        });
      });
    });

    return contact;
  }

  function insertContact(header) {
    const existing = header.querySelector(CONTACT_SELECTOR);
    if (existing && existing.dataset.capHeaderContact === VERSION) return;

    const contact = buildContact();
    if (existing) {
      existing.replaceWith(contact);
      return;
    }

    const icons = header.querySelector('.header__icons');
    if (icons) header.insertBefore(contact, icons);
    else header.appendChild(contact);
  }

  function closeLocations() {
    document.querySelectorAll('[data-cap-header-location][open]').forEach((location) => {
      location.removeAttribute('open');
    });
  }

  function installDocumentEvents() {
    if (document.documentElement.dataset.capHeaderContactEvents) return;
    document.documentElement.dataset.capHeaderContactEvents = VERSION;

    document.addEventListener('pointerdown', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (target && target.closest(CONTACT_SELECTOR)) return;
      closeLocations();
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeLocations();
    });
  }

  function initialize() {
    const section = document.querySelector(HEADER_SECTION_SELECTOR);
    const header = section && section.querySelector(HEADER_SELECTOR);
    if (!section || !header) return false;

    disableHeaderSearch(section);
    enhanceHomeLinks(section);
    insertContact(header);
    installDocumentEvents();
    return true;
  }

  function initializeWhenReady() {
    if (initialize()) return;
    let attempts = 0;
    const retry = () => {
      attempts += 1;
      if (initialize() || attempts >= 180) return;
      window.requestAnimationFrame(retry);
    };
    window.requestAnimationFrame(retry);
  }

  document.addEventListener('shopify:section:load', () => {
    window.requestAnimationFrame(initializeWhenReady);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWhenReady, { once: true });
  } else {
    initializeWhenReady();
  }
})();
